import React from "react";
import { StatusAlert } from "@/components/auth";
import { withAppBase } from "@/lib/appPaths";
import type { LoginErrorAlertProps } from "./LoginErrorAlert.types";

const LOGIN_STATES = {
  DEFAULT: "default",
  INVALID_CREDENTIALS: "invalid_credentials",
  ACCOUNT_BLOCKED: "account_blocked",
  ACCOUNT_DISABLED: "account_disabled",
  NOT_ACTIVATED: "not_activated",
} as const;

export const LoginErrorAlert: React.FC<LoginErrorAlertProps> = ({ state }) => {
  switch (state) {
    case LOGIN_STATES.INVALID_CREDENTIALS:
      return (
        <StatusAlert
          variant="error"
          title="Sign in failed"
          message="Incorrect email or password. Please check your credentials and try again."
        />
      );
    case LOGIN_STATES.ACCOUNT_BLOCKED:
      return (
        <StatusAlert
          variant="error"
          title="Account Blocked"
          message="Your admin account has been blocked. Contact support for assistance."
          action={
            <a
              href="mailto:support@smartstore.com"
              className="text-sm font-medium text-rose-700 dark:text-rose-300 hover:underline"
            >
              Contact Support
            </a>
          }
        />
      );
    case LOGIN_STATES.ACCOUNT_DISABLED:
      return (
        <StatusAlert
          variant="warning"
          title="Account Disabled"
          message="Your account is currently disabled. Please contact your administrator to re-enable access."
        />
      );
    case LOGIN_STATES.NOT_ACTIVATED:
      return (
        <StatusAlert
          variant="info"
          title="Account Not Activated"
          message="Your account is not activated yet. Please accept your invitation first to complete registration."
          action={
            <a
              href={withAppBase("/invite/accept")}
              className="text-sm font-medium text-blue-700 dark:text-blue-300 hover:underline"
            >
              Accept Invitation
            </a>
          }
        />
      );
    default:
      return null;
  }
};
